import { createFileRoute } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { authUserQueries } from '@/http/api/authUser'
import { AvatarForm } from '@/user/components/Settings/AvatarForm'
import { NotificationsForm } from '@/user/components/Settings/NotificationsForm'
import { Onboarding } from '@/user/components/Settings/Onboarding'
import { Preferences } from '@/user/components/Settings/Preferences'
import { UserDetails } from '@/user/components/Settings/UserDetails'

export const Route = createFileRoute('/user/settings/general-settings')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-general-settings',
        }),
      },
    ],
  }),
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(authUserQueries.consentsList())
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator />,
})

function RouteComponent() {
  return (
    <>
      <AvatarForm />
      <UserDetails />
      <Preferences />
      <NotificationsForm />
      <Onboarding />
    </>
  )
}
